import { Component, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Router } from '@angular/router';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { State } from 'src/app/shared/enums/state.enum';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { Service } from 'src/app/shared/models/service';
import { Prestation, PrestationStatut, PrestationStatutColor, PrestationStatutString, PrestationTrackHourColor, PrestationType, StatutBeneficiaireString } from 'src/app/shared/models/prestation';
import { ECharts, EChartsOption } from 'echarts';
import { Region } from 'src/app/shared/models/region';
import { BonCommande } from 'src/app/shared/models/bonCommande';
import { BonCommandeService } from 'src/app/shared/models/bonCommandeService';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { BonCommandeReference } from 'src/app/shared/models/bonCommandeReference';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	planningNeedSolution = false;
	planningNeedValidation = false;
	currentWeekNumber: number;
	nextWeekNumber: number;

	nbBeneficiaire = 0;
	nbQualification = 0;
	nbPrestationEnCours = 0;
	nbPrestationOuvert = 0;
	nbPrestationAnnulees = 0;
	nbPrestationCloturees = 0;
	selectedService: Service;
	selectedRegion: Region;

	chartOptionChart1: EChartsOption;
	chartOptionDetailsPrestation: EChartsOption;
	chartInstance!: ECharts;

	prestationList: Prestation[] = [];
	activitePrestationList: ActivitePrestation[] = [];
	bdcList: BonCommande[] = [];
	chartsBdc: EChartsOption[] = [];
	chartsBdcReferences: EChartsOption[][] = [];

	StatutBeneficiaireString = StatutBeneficiaireString;

	displayMapButton = false;

	isPlanificatrice = false;
	isIntervenant = false;

	chart1String: string;

	today = new Date();
	routeState = State;

	/* Partie messagerie */
	listNotification: MessageNotification[] = [];
	manyNewMessages: boolean = true;

	/* Liste des box d'information à afficher */
	boxList: {
		colorId: number;
		value: number;
		units: string;
		title: string;
		subtitle: string;
	}[] = [];

	constructor(
		private facade: FacadeService,
		private router: Router,
		private dateUtils: DateUtils
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
	}

	ngOnInit(): void {
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();

		this.initDashboardVariables();
		this.selectedService = this.facade.dataStorageService.getService();
		this.selectedRegion = this.facade.dataStorageService.getRegion();

		//if (this.facade.dataStorageService.isPlanificatrice()) {
		// this.getViewableCenters();
		this.initializeBox();
		//}

		this.getMessagingNotifications();
		if (this.selectedService != null) {
			this.facade.beneficiaireService.getByServiceAndRegion(this.selectedService?.id, this.selectedRegion?.id).subscribe({
				next: (val) => {
					this.nbBeneficiaire = val.length;
				}
			})
			// this.facade.qualificationService.getQualificationByService(this.selectedService?.id).subscribe({
			// 	next: (val) => {
			// 		this.nbQualification = val.length;
			// 	}
			// })
			this.facade.prestationService.getPrestationByServiceAndRegion(this.selectedService?.id, this.selectedRegion?.id).subscribe({
				next: (val) => {
					this.nbPrestationEnCours = 0;
					this.nbPrestationAnnulees = 0;
					this.nbPrestationOuvert = 0;
					this.nbPrestationCloturees = 0;
					val.forEach((f) => {
						if (f.statut == PrestationStatut.COURS) {
							this.nbPrestationEnCours++;
						}
						if (f.statut == PrestationStatut.ANNULE) {
							this.nbPrestationAnnulees++;
						}
						if (f.statut == PrestationStatut.CLOT) {
							this.nbPrestationCloturees++;
						}
						if (f.statut == PrestationStatut.OUVERT) {
							this.nbPrestationOuvert++;
						}
					})
					var colorPalette = [PrestationStatutColor.COURS, PrestationStatutColor.OUVERT, PrestationStatutColor.ANNULE, PrestationStatutColor.CLOT];
					this.chartOptionDetailsPrestation = {
						title: {
							text: 'Répartition des prestations',
							left: 'center',
							top: 20,
							textStyle: {
								color: '#262c5e',
								fontFamily: 'Comfortaa, cursive'
							}
						},
						tooltip: {
							trigger: 'item',
							formatter: "{a} <br/>{b} : {c} ({d}%)"
						},
						series: [
							{
								name: 'Répartition des prestations',
								type: 'pie',
								radius: '55%',
								center: ['50%', '60%'],
								data: [
									{
										value: this.nbPrestationEnCours, name: 'Prestations en cours', label: {
											fontFamily: 'Comfortaa, cursive',
											color: '#262c5e',
										}
									},
									{
										value: this.nbPrestationOuvert, name: 'Prestations ouvertes', label: {
											fontFamily: 'Comfortaa, cursive',
											color: '#262c5e',
										}
									},
									{
										value: this.nbPrestationAnnulees, name: 'Prestations annulées', label: {
											fontFamily: 'Comfortaa, cursive',
											color: '#262c5e',
										}
									},
									{
										value: this.nbPrestationCloturees, name: 'Prestations clôturées', label: {
											fontFamily: 'Comfortaa, cursive',
											color: '#262c5e',
										}
									}
								],
								color: colorPalette,
							}
						],
						graph: {
							color: colorPalette
						}
					};

					this.chartOptionChart1 = {
						title: {
						  text: 'Répartition géographique des prescriptions',
						  left: 'center',
						  top: 20,
						  textStyle: {
							color: '#262c5e',
							fontFamily: 'Comfortaa, cursive'
						  }
						},
						tooltip: {
						  trigger: 'item',
						  formatter: "{a} <br/>{b} : {c} ({d}%)"
						},
						series: [
						  {
							name: 'Répartition géographique des prescriptions',
							type: 'pie',
							radius: '55%',
							center: ['50%', '60%'],
							data: this.facade.dataStorageService.getRegion().departements.map(p => ({
							  name: p.name+"("+p.code+")",
							  value: this.prestationList!.filter(e => e.typePrestation == PrestationType.QD 
								  && e.beneficiaire.departement != null && e.beneficiaire?.departement?.id 
								  == p.id).length
							})),
						  }
						]
					  };
				}
			})

			this.facade.bonCommandeService.getBonCommandeByServiceAndRegion(this.selectedService?.id, this.selectedRegion?.id).subscribe({
				next: (val) => {
					this.bdcList = val;
					val.forEach((e, i) => {
						this.facade.prestationService.getPrestationByBonCommandeDashboard(e.id).subscribe({
							next: (prestations) => {
								this.prestationList = prestations;
								this.activitePrestationList = [];
								this.chartsBdc.push(this.initBdcChart(e));
								if (e.references) {
									e.references.forEach(f => {
										console.log(f.cible);
										this.facade.activitePrestationService.getActivitePrestationByBonCommandeReference(f.id).subscribe({
											next: (activites) => {
												this.activitePrestationList = activites;
												if (!this.chartsBdcReferences[i]) {
													this.chartsBdcReferences[i] = [];
												  }
												this.chartsBdcReferences[i].push(this.initBdcReferenceChart(e, f))
											}
										})
									})
								}
								// var colorPalette = [PrestationTrackHourColor.CONSOMME, PrestationTrackHourColor.RESTANT];
								// let chartOptionBdc: EChartsOption;
								// chartOptionBdc = {
								// 	title: {
								// 		text: e.marche + " " + e.description + " " + e.lot,
								// 		left: 'center',
								// 		top: 20,
								// 		textStyle: {
								// 			color: '#262c5e',
								// 			fontFamily: 'Comfortaa, cursive'
								// 		}
								// 	},
								// 	tooltip: {
								// 		trigger: 'item',
								// 		formatter: "{a} <br/>{b} : {c} ({d}%)"
								// 	},
								// 	series: [
								// 		{
								// 			name: e.marche + " " + e.description + " " + e.lot,
								// 			type: 'pie',
								// 			radius: '55%',
								// 			center: ['50%', '60%'],
								// 			data: [
								// 				{
								// 					value: this.calculateVolumeHoraireBdcPrevByService(), name: 'Heures consommées', label: {
								// 						fontFamily: 'Comfortaa, cursive',
								// 						color: '#262c5e',
								// 					}
								// 				},
								// 				{
								// 					value: this.calculateVolumeHoraireTotalBdcByService(e) - this.calculateVolumeHoraireBdcPrevByService(), name: 'Volume horaire disponible', label: {
								// 						fontFamily: 'Comfortaa, cursive',
								// 						color: '#262c5e',
								// 					}
								// 				}
								// 			],
								// 			color: colorPalette,

								// 		}
								// 	],
								// 	graph: {
								// 		color: colorPalette
								// 	}
								// };
								// this.chartsBdc.push(chartOptionBdc);

								// e.references.forEach(f => {
								// 	var colorPalette = [PrestationTrackHourColor.CONSOMME, PrestationTrackHourColor.RESTANT];
								// 	let chartOptionBdcReference: EChartsOption;
								// 	chartOptionBdcReference = {
								// 		title: {
								// 			text: StatutBeneficiaireString[f.cible],
								// 			left: 'center',
								// 			top: 20,
								// 			textStyle: {
								// 				color: '#262c5e',
								// 				fontFamily: 'Comfortaa, cursive'
								// 			}
								// 		},
								// 		tooltip: {
								// 			trigger: 'item',
								// 			formatter: "{a} <br/>{b} : {c} ({d}%)"
								// 		},
								// 		series: [
								// 			{
								// 				name: StatutBeneficiaireString[f.cible],
								// 				type: 'pie',
								// 				radius: '55%',
								// 				center: ['50%', '60%'],
								// 				data: [
								// 					{
								// 						value: this.calculateVolumeHoraireBdcReferenceReelByService(f), name: 'Heures consommées', label: {
								// 							fontFamily: 'Comfortaa, cursive',
								// 							color: '#262c5e',
								// 						}
								// 					},
								// 					{
								// 						value: this.calculateVolumeHoraireTotalBdcReferenceByService(e, f) - this.calculateVolumeHoraireBdcReferenceReelByService(f), name: 'Volume horaire disponible', label: {
								// 							fontFamily: 'Comfortaa, cursive',
								// 							color: '#262c5e',
								// 						}
								// 					}
								// 				],
								// 				color: colorPalette,

								// 			}
								// 		],
								// 		graph: {
								// 			color: colorPalette
								// 		}
								// 	};
								// 	console.log("before display");
								// 	this.chartsBdcReferences.push(chartOptionBdcReference);
								// })
							},
						})
					})
				}
			})
		}
	}

	getViewableCenters() {
		this.facade.centerService.getAllViewableCenter().subscribe((centers) => {
			let mappedCenter: { id: number; name: string; type: number }[] = [];
			centers.forEach((center) => {
				mappedCenter.push({
					id: center.id,
					name: center.name,
					type: center.type
				});
			});
			this.facade.dataStorageService.setParam(
				'listCenterViewableInPlanning',
				mappedCenter
			);
		});
	}

	initBdcChart(bonCommande: BonCommande): EChartsOption {
		var colorPalette = [PrestationTrackHourColor.CONSOMME, PrestationTrackHourColor.RESTANT];
		let chartOptionBdc: EChartsOption;
		chartOptionBdc = {
			title: {
				text: bonCommande.commande,
				left: 'center',
				top: 20,
				textStyle: {
					color: '#262c5e',
					fontFamily: 'Comfortaa, cursive'
				}
			},
			tooltip: {
				trigger: 'item',
				formatter: "{a} <br/>{b} : {c} ({d}%)"
			},
			series: [
				{
					name: bonCommande.commande,
					type: 'pie',
					radius: '55%',
					center: ['50%', '60%'],
					data: [
						{
							value: this.calculateVolumeHoraireBdcPrevByService(), name: 'Heures consommées', label: {
								fontFamily: 'Comfortaa, cursive',
								color: '#262c5e',
							}
						},
						{
							value: this.calculateVolumeHoraireTotalBdcByService(bonCommande) - this.calculateVolumeHoraireBdcPrevByService(), name: 'Volume horaire disponible', label: {
								fontFamily: 'Comfortaa, cursive',
								color: '#262c5e',
							}
						}
					],
					color: colorPalette,

				}
			],
			graph: {
				color: colorPalette
			}
		};
		return chartOptionBdc;
	}

	initBdcReferenceChart(bonCommande: BonCommande, bonCommandeReference: BonCommandeReference): EChartsOption {
		var colorPalette = [PrestationTrackHourColor.CONSOMME, PrestationTrackHourColor.RESTANT];
		let chartOptionBdcReference: EChartsOption;
		chartOptionBdcReference = {
			title: {
				text: StatutBeneficiaireString[bonCommandeReference.cible],
				left: 'center',
				top: 20,
				textStyle: {
					color: '#262c5e',
					fontFamily: 'Comfortaa, cursive'
				}
			},
			tooltip: {
				trigger: 'item',
				formatter: "{a} <br/>{b} : {c} ({d}%)"
			},
			series: [
				{
					name: StatutBeneficiaireString[bonCommandeReference.cible],
					type: 'pie',
					radius: '55%',
					center: ['50%', '60%'],
					data: [
						{
							value: this.calculateVolumeHoraireBdcReferenceReelByService(bonCommandeReference), name: 'Heures consommées', label: {
								fontFamily: 'Comfortaa, cursive',
								color: '#262c5e',
							}
						},
						{
							value: this.calculateVolumeHoraireTotalBdcReferenceByService(bonCommande, bonCommandeReference) - this.calculateVolumeHoraireBdcReferenceReelByService(bonCommandeReference), name: 'Volume horaire disponible', label: {
								fontFamily: 'Comfortaa, cursive',
								color: '#262c5e',
							}
						}
					],
					color: colorPalette,

				}
			],
			graph: {
				color: colorPalette
			}
		};
		return chartOptionBdcReference;
	}

	getMessagingNotifications() {
		// this.facade.notificationService
		// 	.getMessageNotifications(this.facade.dataStorageService.getUser()?.id)
		// 	.subscribe((notifications) => {
		// 		this.listNotification = notifications;
		// 		this.listNotification.sort();
		// 	});
	}

	initializeBox() {
		this.boxList.push(
			{
				colorId: 1,
				value: 47,
				units: '',
				title: 'Nombre de bénéficiaires :',
				subtitle: ''
			},
			{
				colorId: 2,
				value: 20,
				units: '',
				title: 'Nombre de qualifications :',
				subtitle: ''
			},
			{
				colorId: 3,
				value: 20,
				units: '',
				title: 'Nombre de prestations en cours :',
				subtitle: ''
			},
		);
	}

	initDashboardVariables() {
		this.displayMapButton = false;
		this.currentWeekNumber = this.dateUtils.getWeekNumber(this.today);
		this.nextWeekNumber = this.dateUtils.getWeekNumber(
			new Date(this.today.getTime() + 7 * 24 * 60 * 60 * 1000)
		);
	}

	onChartInit(ec: ECharts): void {
		this.chartInstance = ec;
	}

	exportChartAsImage(): void {
		const imageBase64 = this.chartInstance.getDataURL({
		  type: 'png',
		  pixelRatio: 2,
		  backgroundColor: '#fff',
		});
	
		const link = document.createElement('a');
		link.href = imageBase64;
		link.download = 'details-prestation.png';
		link.click();

		console.log(imageBase64);
	}

	validerPlanning(weekNumber: number) {
		this.facade.dataStorageService.setParam(
			'planningValidationRedirected',
			true
		);
		this.facade.dataStorageService.setParam(
			'planningValidationRedirectedWeekNumber',
			weekNumber
		);

		this.router.navigate(['/planning']);
	}

	buildSolutionPlanning(weekNumber: number) {
		this.facade.dataStorageService.setParam(
			'planningBuildSolutionRedirected',
			true
		);
		this.facade.dataStorageService.setParam(
			'planningBuildSolutionRedirectedWeekNumber',
			weekNumber
		);

		this.router.navigate(['/planning']);
	}

	calculateVolumeHoraireBdcPrevByService(): number {
		let total = 0;
		this.prestationList?.forEach(e => {
			if (this.selectedService.id == e.service?.id) {
				total = total + e.duree;
			}
		})
		return total;
	}

	calculateVolumeHoraireBdcReferenceReelByService(bonCommandeReference: BonCommandeReference): number {
		let total = 0;
		this.activitePrestationList?.forEach(e => {
			if (this.selectedService.id == e.prestation.service?.id
				&& e.prestation.statutBeneficiaire == bonCommandeReference.cible) {
				total = total + e.chargeTravail;
			}
		})
		return total;
	}

	calculateVolumeHoraireTotalBdcByService(bonCommande: BonCommande): number {
		let totalByService = 0;
		let total = 0;
		bonCommande?.references?.forEach((e) => {
			total = total + e.quantite;
		})
		bonCommande.services.filter(f => {
			if (f.service.id == this.selectedService.id) {
				totalByService = total * f.pourcentageCharge / 100;
			}
		})
		return totalByService;
	}

	calculateVolumeHoraireTotalBdcReferenceByService(bonCommande: BonCommande, bonCommandeReference: BonCommandeReference): number {
		let bonCommandeService = bonCommande.services.find(f => f.service.id == this.selectedService.id)
		let total = bonCommandeReference.quantite * bonCommandeService.pourcentageCharge / 100;
		return total;
	}


}
